<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button type="primary" @click="ejectaddGoods(1)">新增分类</el-button>
      </el-form-item>
    </el-form>
    <!-- 分类表格 -->
    <el-table
      border
      :data="dataList"
      style="width: 100%;overflow-y: scroll !important;"
      height="calc(100vh - 220px)"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
 
      element-loading-text="正在加载中"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="180"
      ></el-table-column>
      <el-table-column label="分类ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分类主图" width="100" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.img" alt style="width:100%" />
        </template>
      </el-table-column>
      <el-table-column label="分类名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.categoryName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否显示" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.status == 0 ? "显示" : "隐藏" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="ejectupdataGoods(scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="是否显示分类: " style="margin-left:20px">
          <el-select v-model="form.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" :label-width="formLabelWidth">
          <el-input v-model="form.categoryName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <!-- 上传文件到服务器 -->
      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="true"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
      >
        <el-button size="small" type="primary">点击上传分类主图(1张)</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，500px X 500px, 会自动覆盖原来的图片
        </div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectCategory,
  updateCategory,
  deleteCategory,
  addCategory,
} from "@/services/mall/goods";
import { IP } from "@/services/index.js";
export default {
  created() {
    this.select();
  },

  data() {
    return {
      goodsTitle: "",
      tableData: [],
      // 一级分类 二级分类 分类
      selectCategory: "",
      select_two_id: "",
      categoryArr: [
        { id: "0", name: "一级分类" },
        { id: "1", name: "二级分类" },
      ],
      categoryArr_one: [], //遍历一级分类
      parentId: "", //增加二级分类时选择的一级分类id
      isAddCategoryOne: 1, //增加一级分类还是二级分类
      dataList: [],
      goodsArr: [],
      dialogFormVisible: false,
      inpitTypeName: "",
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: true,
      pageCount: "",
      pageSize: 8,
      form: {
        productCategory: 1,
      },
      shuf: [],
      cover: [],
      describe: [],
      statusList: [
        {
          name: "显示",
          id: 0,
        },
        {
          name: "隐藏",
          id: 1,
        },
      ],
    };
  },
  methods: {
    select(id) {
      // 查分类
      selectCategory(id).then((resp) => {

        this.dataList = resp.data;
        this.loading = false;
      });
    },
    init() {
      this.$message({
        type: "success",
        message: "查询成功!",
      });
    },
    info() {
      this.$message({
        type: "info",
        message: "查询失败",
      });
    },
    ejectupdataGoods(row) {
      
      this.fileList = [];
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改分类";
      this.form = JSON.parse(JSON.stringify(row));
    },
    ejectaddGoods(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增分类";
      this.fileList = [];
      this.form = {};
    },

    handleSuccess_cover(e) {
      console.log(e);
      this.form.img = e.data;
    },
    // 提交表单按钮
    updataBtn() {
      console.log("点击了确认");
      let categoryName = this.form.categoryName;
      if (categoryName == "" || categoryName == undefined) {
        this.$message({
          type: "info",
          message: "请输入分类名称",
        });
        return;
      }
      if (this.inpitTypeName == "修改分类") {
        console.log("修改分类------------");
        updateCategory(this.form).then((resp) => {
  
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogFormVisible = false;
            this.select();
          } else {
            this.info();
          }
        });
      } else if (this.inpitTypeName == "新增分类") {
        addCategory(this.form).then((res) => {
   
          this.$message({
            type: "success",
            message: "新增成功!",
          });
          this.dialogFormVisible = false;
          this.select();
        });
      }
    },

    handleDelete(row) {
      console.log("handleDelete==============", row.id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteCategory(row.id).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCurrentChange(e) {
      console.log("当前页：", e);
      this.selectAll(this.goodsTitle, e);
    },
    prevClick(e) {
      console.log("上一页:", e);
      this.selectAll(this.goodsTitle, e);
    },
    nextClick(e) {
      console.log("下一页:", e);
      this.selectAll(this.goodsTitle, e);
    },
  },
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
</style>
